export default "__VITE_ASSET__C4ME72K2__"